import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Loading from "../Loading/Loading";
import httpService from "../../common/http.service";


const Articleslist = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const lang = i18n.language.toUpperCase();
    const [articles, setArticles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const itemsPerPage = 50;
    const DEFAULT_IMAGE = `${process.env.REACT_APP_IMG_URL}images/files-test/1734705843913.jpeg`;
    const handleClick = (id) => {
        navigate(`/article/${id}`);
    };

    const Next = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const Prev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    const fetchArticles = async () => {
        setLoading(true);
        try {
            const response = await httpService.get(`article/search`, {
                articlecategory: id,
                language: lang,
                sort: "ASC",
                status: 0,
                page: currentPage,
                limit: itemsPerPage,
            });
            
            const { data, totalNumber } = response.data;
            setArticles(data);
            const calculatedTotalPages = Math.ceil(totalNumber / itemsPerPage);
            setTotalPages(calculatedTotalPages);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [lang, id]);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchArticles();
    }, [id, currentPage, lang]);

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="flex flex-col items-center justify-start min-h-screen py-4">
            <h2 className="mt-1 mb-3 text-center text-[#f16334] font-poppins">
                Articles
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 justify-items-center">
                {articles?.length > 0 &&
                    articles.map((article, index) => (
                        <div
                            key={index}
                            onClick={() => handleClick(article._id)}
                            className="bg-white w-72 rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-xl transition duration-300 cursor-pointer"
                        >
                            <div className="h-44 w-full overflow-hidden">
                                <img
                                    alt="article"
                                    src={
                                        article.image ||
                                        DEFAULT_IMAGE
                                    }
                                    className="object-cover w-full h-full"
                                />
                            </div>
                            <div className="relative p-4 h-32 bg-white shadow rounded-md">
                                <h2 className="text-lg font-semibold text-gray-800">
                                    {(article.name?.length > 40 ? article.name.slice(0, 40) + "..." : article.name) || "Article Title"}
                                </h2>
                                {/* Description if needed */}
                                {/* <p className="text-sm text-gray-500 mt-1">
                                    {(article.description?.length > 20
                                        ? article.description.slice(0, 20) + "..."
                                        : article.description) || "Lorem Ipsum is simply..."}
                                </p> */}
                                <p className="text-sm text-red-500 font-medium absolute bottom-0 left-6">
                                    Read More
                                </p>
                            </div>

                        </div>
                    ))}
            </div>

            <div className="flex items-center gap-4 mt-4">
                <button
                    onClick={Prev}
                    disabled={currentPage === 1}
                    className="px-4 py-2 bg-[#f16334] text-white rounded hover:bg-[#d6522d] disabled:opacity-50"
                >
                    Prev
                </button>
                <span className="text-[#f16334] font-semibold">
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    onClick={Next}
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 bg-[#f16334] text-white rounded hover:bg-[#d6522d] disabled:opacity-50"
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Articleslist; 